module.exports = __webpack_public_path__ + "img/comp_tom.c0d8f178.png";